import { Directive, OnDestroy } from '@angular/core';
import { MonoTypeOperatorFunction, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
export class Destroyable implements OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  takeUntilDestruction = <T>(): MonoTypeOperatorFunction<T> =>
    takeUntil(this.destroy$);

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
